(function() {
  function generateFAQSchema() {
    const questions = [];

    // 1. Add Page Title/Meta Description as the first FAQ (Primary)
    const pageTitle = document.title;
    const metaDesc = document.querySelector('meta[name="description"]')?.content;

    if (pageTitle && metaDesc) {
      questions.push({
        "@type": "Question",
        "name": pageTitle,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": metaDesc
        }
      });
    }

    // 2. Scan H2 and H3 tags and treat them as questions
    // We look for the immediately following P tag for the answer.
    const headings = document.querySelectorAll('h2, h3');
    headings.forEach(heading => {
      const questionText = heading.innerText.trim();
      let answerText = '';

      // Find the next sibling that is a paragraph or div with text
      let nextElement = heading.nextElementSibling;
      while (nextElement) {
        if (nextElement.tagName === 'P' || nextElement.tagName === 'DIV') {
            answerText = nextElement.innerText.trim();
            break; // Found the answer
        }
        // If we hit another heading, stop looking for an answer for this one
        if (['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(nextElement.tagName)) {
            break;
        }
        nextElement = nextElement.nextElementSibling;
      }

      if (questionText && answerText) {
        questions.push({
          "@type": "Question",
          "name": questionText,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answerText
          }
        });
      }
    });

    if (questions.length > 0) {
      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": questions
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      console.log('FAQ Schema Injected:', schema);
    }
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', generateFAQSchema);
  } else {
    generateFAQSchema();
  }
})();
